import { useEffect, useState } from "react";
import {
  ISocketReturn,
  TypeSockectEvent,
} from "../../../../libs/types/sockets";
import { IUser } from "../../../../libs/types/users";
import { useLoginContext } from "../context";
import DataFunctions from "../functions/database";
import UsersAPI from "../services/api/users";
import { socket } from "../services/socket";

const room: TypeSockectEvent = "user_update";

const useUsersSocket = () => {
  const [data, setData] = useState<IUser[]>([]);
  let auth = useLoginContext();

  useEffect(() => {
    getBase();
  }, []);

  useEffect(() => {
    if (socket && socket.connected) {
      socket.on(room, (io: ISocketReturn) => {
        //console.log(room, io);

        const ioData: IUser = io.data;
        const index = data.findIndex(
          (item) =>
            new DataFunctions().getId(item) ===
            new DataFunctions().getId(ioData)
        );

        var current_data: IUser[] = [...data];

        switch (io.socketReturn) {
          case "add":
            current_data.push(ioData);
            break;

          case "update":
            if (index > -1) current_data[index] = ioData;
            break;

          case "delete":
            current_data = data.filter(
              (item) =>
                new DataFunctions().getId(item) !==
                new DataFunctions().getId(ioData)
            );
            break;
        }

        setData(current_data);
      });
    }
  }, [socket, data]);

  const getBase = async () => {
    if (auth.loginDataContext.master) {
      new UsersAPI().list().then(async (res) => {
        if (res.success) await setData(res.data);
      });
    } else {
      new UsersAPI()
        .listByOwner(auth.loginDataContext.id ? auth.loginDataContext.id : "")
        .then(async (res) => {
          if (res.success) await setData(res.data);
        });
    }
  };

  return data;
};

export default useUsersSocket;
